import script from "./EdgeProperties.vue?vue&type=script&setup=true&lang=js"
export * from "./EdgeProperties.vue?vue&type=script&setup=true&lang=js"

import "./EdgeProperties.vue?vue&type=style&index=0&id=0654901c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0654901c"]])

export default __exports__